const showcaseRouter = {
  route: null,
  name: null,
  title: '案例管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'views/b_showcase/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '添加案例',
      type: 'view',
      name: 'showcaseAdd',
      route: '/b_showcase/add',
      filePath: 'plugins/b_showcase/views/ShowcaseAdd.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '案例列表',
      type: 'view',
      name: 'showcaseList',
      route: '/b_showcase/list',
      filePath: 'plugins/b_showcase/views/ShowcaseList.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
  ],
}

export default showcaseRouter
